module.exports = __webpack_public_path__ + "fonts/montserrat-latin-600.0480d2f.woff2";